import { render, staticRenderFns } from "./ElementsModal.vue?vue&type=template&id=7ffaab50&scoped=true&"
import script from "./ElementsModal.vue?vue&type=script&lang=js&"
export * from "./ElementsModal.vue?vue&type=script&lang=js&"
import style0 from "./ElementsModal.vue?vue&type=style&index=0&id=7ffaab50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffaab50",
  null
  
)

export default component.exports